import { confirmAlert } from 'react-confirm-alert';

import { ResetConfirmation } from './ResetConfirmation';

export interface ResetConfirmationProps {
  onConfirm: VoidFunction;
  onReject?: VoidFunction;
}

export const confirmReset = ({
  onConfirm,
  onReject = undefined,
}: ResetConfirmationProps): void => {
  confirmAlert({
    customUI: ({ onClose }) => {
      return (
        <ResetConfirmation
          onConfirm={() => {
            onConfirm();
            onClose();
          }}
          onReject={() => {
            onReject?.();
            onClose();
          }}
        />
      );
    },
  });
};
